import React from 'react'
import PropTypes from 'prop-types'
import classnames from './loader.module.css'

const Loader = ({width, height}) => {
  const style = {width, height}
  return (
    <div
      className={classnames['loader-wrapper']}
      style={style}
    >
      <div className={classnames['loader']} />
    </div>
  )
}

Loader.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

Loader.defaultProps = {
  width: 20,
  height: 20,
}

export { Loader }
